import { render, staticRenderFns } from "./ShortcutsWebpartTest.vue?vue&type=template&id=9c678730"
import script from "./ShortcutsWebpartTest.vue?vue&type=script&lang=js"
export * from "./ShortcutsWebpartTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports